<template>
  <div class="card-item spore" style="height: 50%;">
    <div class="subtitle">
      智能孢子仪
    </div>

    <div v-if="!loading && !data.length" class="no-data">
      暂无数据
    </div>

    <el-carousel
      v-else
      trigger="click"
      style="padding: 0 20px;box-sizing: border-box;"
      :height="`${height - 40}px`"
      v-loading="loading"
      element-loading-background="rgba(0, 0, 0, 0.3)"
    >
      <el-carousel-item v-for="item in data" :key="item.id">
        <el-image
          fit="fill"
          :src="item.storePath"
          :style="`height: ${height - 40}px`"
        ></el-image>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import mixin from '../mixin'
import { getPictures } from '@/service/spore'
import { subtract } from '@/utlis/date'

export default {
  mixins: [mixin],
  data() {
    return {
      loading: true,
      data: []
    }
  },
  mounted() {
    const deviceId = this.spores && this.spores[0] ? this.spores[0].id : null
    this.getData({
      page: 1,
      limit: 4,
      companyId: this.companyId,
      deviceId,
      beginDate: subtract(undefined, 30, 'days', 'YYYY-MM-DD 00:00:00')
    })
  },
  methods: {
    async getData(query = {}) {
      this.loading = true
      const { data } = await getPictures(query)
      this.data = data.pictures
      this.loading = false
    }
  }
}
</script>

<style lang="scss">
.card-item.spore {
  .el-carousel__button {
    width: 24px;
  }
  .el-image {
    width: 100%;
  }
  .no-data {
    width: 100%;
    height: 100%;
  }
}
</style>
